import styled from "styled-components";

const Information = styled.div`
  position: absolute;
  z-index: 1;
  top: 60px;
  right: 90px;

  @media (max-width: 1599px) {
    top: 40px;
    right: 50px;
  }
  @media (max-width: 1199.98px) {
    top: 30px;
    right: 30px;
  }
  @media (max-width: 767px) {
    top: 20px;
    right: 20px;
  }
  @media (max-width: 575px) {
    top: 10px;
    right: 10px;
  }
`;

export default Information;
